import { FilterIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { NotificationBadge } from 'foundations-components/transitional/components/NotificationBadge';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const FieldTypeFilterButton = ({
  disabled,
  disabledTooltipContent,
  filtersCount,
  onClick
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disabled,
    placement: "right",
    title: disabledTooltipContent,
    children: /*#__PURE__*/_jsx(NotificationBadge, {
      badgeLabel: filtersCount,
      showBadge: typeof filtersCount === 'number' && filtersCount > 0,
      children: /*#__PURE__*/_jsx(IconButton, {
        disabled: disabled,
        onClick: onClick,
        use: "tertiary-extra-light",
        children: /*#__PURE__*/_jsx(FilterIcon, {})
      })
    })
  });
};
export default FieldTypeFilterButton;